import React from 'react';
import { AddToList } from '@thd-olt-component-react/add-to';
import { extend } from '@thd-nucleus/data-sources';
import proptypes from 'prop-types';

const { number, string } = proptypes;

export const BuyboxAddToList = ({ itemId, itemPrice, quantity = 1 }) => {
  return (
    <AddToList
      products={[{ itemId, quantity, price: itemPrice }]}
    />
  );
};

BuyboxAddToList.dataModel = extend(
  AddToList
);

BuyboxAddToList.propTypes = {
  itemId: string.isRequired,
  itemPrice: number,
  quantity: number
};
